import React from 'react'
import {fphoto} from '../../helper/common'
import {MaleUrl} from '../../config/const'

export default function ItemWineeBanner(props) {
  const {item, onDetail} = props
  return (
    <div className={'item_banner_winee'} onClick={onDetail}>
      <img className={'item_banner_winee_profile'} src={fphoto(item.mb_photo, 'member', MaleUrl)} alt={''}/>
      <div className={'p-20 sm-pv-14'}>
        <div className={'fs-18 sm-fs-14 f-b color-3a3335 text-line'}>{item.mb_nick}</div>
        {/* <div className={'fs-14 sm-fs-12 color-8f8f8f mb-20 sm-mb-12 text-line'}>{item.mb_intro1}</div> */}
        {/* <label className={'fs-13 sm-fs-12 color-0f4c81 item-winee-field ph-12 sm-ph-12 pt-1 mb-0 ' + (item.mb_field === '' ? 'invisible' : '')}>{item.mb_field}</label> */}
      </div>
    </div>
  )
}